import { auth } from '@/vendors/firebase/firebase';
/* eslint-disable */
const ls = require('local-storage')
import axios from 'axios';

export default {
  async getUserToken() {
    return auth.currentUser.getIdToken(true);
  },
  async isAuthenticated() {
    return auth.currentUser.getIdToken(true).then((token) => !!token);
  },
  async loginWithCredentials(email, password) {
    const { user } = await auth.signInWithEmailAndPassword(email, password);
    return user;
  },
  async logout() {
    return auth.signOut();
  },
  async listenUserState(cb) {
    return new Promise((resolve) => {
      return auth.onAuthStateChanged((user) => {
        if (cb) { cb(user); }
        resolve(user);
      });
    });
  },
};
